import { useState } from "react";
import { Grid, InputAdornment, TextField } from "@mui/material";
import { Search } from "@mui/icons-material";
import { useDebouncedEffect } from "../../../App/State/Hooks/useDebouncedEffect";

export default function CandidatesCapturedSearchInput({
  defaultSearch,
  handleSetSearch,
  dataTestId,
}: {
  defaultSearch: string;
  handleSetSearch: (newSearch: string) => void;
  dataTestId: string;
}) {
  const [searchInput, setSearchInput] = useState(defaultSearch);
  const handleSearchInput = (event: React.ChangeEvent<HTMLInputElement>) => {
    setSearchInput(event.target.value);
  };

  useDebouncedEffect(
    () => {
      handleSetSearch(searchInput);
    },
    [searchInput],
    500,
  );

  return (
    <TextField
      data-test={dataTestId}
      label="Search"
      value={searchInput}
      onChange={handleSearchInput}
      type="search"
      fullWidth
      InputProps={{
        startAdornment: (
          <InputAdornment position="start">
            <Search />
          </InputAdornment>
        ),
      }}
    />
  );
}
